import { render, staticRenderFns } from "./ChooseService.vue?vue&type=template&id=305c097a&scoped=true&"
import script from "./ChooseService.vue?vue&type=script&lang=js&"
export * from "./ChooseService.vue?vue&type=script&lang=js&"
import style0 from "./ChooseService.vue?vue&type=style&index=0&id=305c097a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305c097a",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QDialog,QCard});qInstall(component, 'directives', {ClosePopup});
